import React from 'react'

import StudioButton from 'material/buttons/StudioButton'
import StudioForm, {yup} from 'studio/StudioForm'
import StudioInput from 'material/input/StudioInput'
import StudioTitleBar from 'studio/StudioTitleBar'


class ConfirmCodeRegisterForm extends StudioForm {
    constructor() {super()
        this.state = {keycode: false}
    }

    formID() {
        return 'confirm-code-form'
    }

    renderChildren(props) {
        return (
            <React.Fragment>
                <StudioInput
                type='text'
                name='keycode'
                labelText={props.errors?.keycode ? props.errors.keycode : 'Six Digit Code'}
                required={true}
                value={props.values?.keycode}
                error={this.state.keycode}
                onChange={props.handleChange}/>

                <StudioButton
                type='submit'
                text='Confirm'
                variant='contained'
                size='large'
                form={this.formID()}/>
            </React.Fragment>
        )
    }

    initialValues() {
        return {keycode: ''}
    }

    onSubmit(values) {
        const params = {
            email: this.SESSION.user.userMail,
            keycode: values.keycode,
        }

        this.REST.POST('verify_mail', params)
        .then(response => this.handleResponse(response))
    }

    handleResponse(response) {
        if (response?.data?.formik_error) {
            this.setState({[response.data.formik_error]: true})
        }

        if (response?.status === 201) {
            this.REST.POST('confirm_code_register_form', {username: this.SESSION.user.userName})
            return
        }
    }

    formSchema() {
        return yup.object().shape({
            keycode: yup.string()
            .min(6, 'Too Short')
            .max(6, 'Too Long'),
        })
    }

    renderTitleBar() {
        return <StudioTitleBar title='Confirmation Code'/>
    }
}


export default ConfirmCodeRegisterForm
